import React from 'react';
import { Box, Card, CardContent, Autocomplete, TextField } from '@mui/material';

const EmployeeDashboardFilters = ({
  employeeFilter,
  filterOptions,
  employeesList = [],
  onFilterChange,
  disableCard = false,
}) => {
  const employeesData = filterOptions?.employees || employeesList;
  const employeeOptions =
    employeesData && employeesData.length > 0
      ? employeesData.map((employee) => ({
          value: employee.id,
          label: employee.employee_id ? `${employee.full_name} (${employee.employee_id})` : employee.full_name,
        }))
      : [];

  const autocomplete = (
    <Autocomplete
      size="small"
      fullWidth
      value={employeeOptions.find((opt) => opt.value?.toString() === employeeFilter?.toString()) || null}
      onChange={(event, newValue) => {
        onFilterChange('employee', newValue?.value || '');
      }}
      options={employeeOptions}
      getOptionLabel={(option) => option?.label || ''}
      isOptionEqualToValue={(option, value) => option?.value?.toString() === value?.value?.toString()}
      renderInput={(params) => <TextField {...params} label="Employee" placeholder="Select employee" />}
      clearOnEscape
    />
  );

  if (disableCard) {
    return (
      <Box sx={{ width: '100%', minWidth: 0, maxWidth: { xs: '100%', md: 440 } }}>{autocomplete}</Box>
    );
  }

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: { xs: '100%', sm: 320 },
              maxWidth: '100%',
            }}
          >
            {autocomplete}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default EmployeeDashboardFilters;
